import { useState } from 'react'
import { VscChevronDown, VscChevronRight } from "react-icons/vsc";

import './homeTap.scss'

function HomeTap() {  
  const [openTab, setOpenTab] = useState<{[number: number]: boolean }>({})
 
  const openTap = (value: number) => {
    const isActive = openTab[value]
    const newTapList = {...openTab, [value]: !isActive }
    setOpenTab(newTapList)
  }

  const renderTap = (config: Array<{ title: string, id: number, disabled?: boolean }>) => {
    return config.map(tap => {
      return (
        <div key={tap.title + tap.id} className={`content-tapItem ${openTab[tap.id] && 'content-tapItemOpen'}`}>
          <div className={`tapItem-header ${!tap.disabled && 'tapItem-headerActive'}`} onClick={() => tap.disabled ? null : openTap(tap.id)}>
            <div className='header-icon'>
              {!openTab[tap.id] && <VscChevronRight />}
              {openTab[tap.id] && <VscChevronDown />}
            </div>
            <div className='header-title'>{tap.title}</div>
          </div>
          <div className={`tapItem-content ${openTab[tap.id] && 'tapItemOpen'}`}>
            <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              under construction
            </div>
          </div>
        </div>
      )
    })
  }

  return (
    <div className='explorer-homeTap'>
      <div className='homeTap-header'>EXPLORER</div>
      <div className='homeTap-content'>

        {renderTap([
          { title: 'Dwain', id: 0 },
          { title: 'Outline', id: 1, disabled: true },
          { title: 'Timeline', id: 2, disabled: true },
          { title: 'Npm Scripts', id: 3, disabled: true }
        ])}

      </div>
    </div>
  )
}

export default HomeTap
